const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

export const RawImageUploadQueryURL = {
    GetPhotoTypes: Backofficebff + '/v1/raw-image-upload/photo-types',
};
